import React from "react";
import { Button, Card, CardBody, CardHeader, Col, Row } from "reactstrap";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import Page from "../../Page";
import { FetchListadoCoberturas } from "../../../redux/actions/aEndososBeneficiarios";
import SeleccionEndososHogar from "./SeleccionEndososHogar";
import { Checkbox } from "react-inputs-validation";

class CoberturasHogar extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            activePage: 1,
            datosEndosos: {
                datosEndosos: []
            },
            listado: [],
            filtro: "",
            filtroValor: "",
            first: 0,
            rows: 10,
            totalRecords: 0,
            poliza: "",
            sucursal: "",
            ramo: "",
            paso: "coberturas",
            coberturasSeleccionadasChecked: {
                "Estructura": false,
                "Contenidos": false
            },
            coberturasSeleccionadas: {
            },
            sumasAseguradas: {}
        };
    }

    async componentDidMount() {
        const {
            poliza,
            sucursal,
            ramo,
            ciudad,
            direccion,
            provincia,
            cod_item,
            ramo_tec,
            subramo,
            amparo,
            categoria
        } = this.props.general;

        const body = {
            poliza,
            sucursal,
            ramo,
            ciudad,
            direccion,
            provincia,
            cod_item,
            ramo_tec,
            subramo,
            amparo,
            categoria
        };
        await this.props.listadoEndososRamo({
            empCodigo: "AIGMETROPOLITANA",
            ...body
        })
        this.setState(body);
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.datosEndosos !== prevProps.datosEndosos) {
            if (this.props.datosEndosos !== undefined &&
                this.props.datosEndosos.datosEndosos !== undefined
            ) {
                if (this.props.datosEndosos.datosEndosos["coberturas"] !== undefined) {
                    this.setState({
                        listado: this.props.datosEndosos.datosEndosos["coberturas"],
                        totalRecords: this.props.datosEndosos.datosEndosos["coberturas"].length
                    });
                } else {
                    this.setState({
                        listado: [],
                        totalRecords: 0
                    });
                }

            }

        }

        if (this.state.listado) {

        }
    }

    renderDataRamo = () => {
        return (
            <Row style={{ marginLeft: 0 }}>
                <Col>
                    <Row>
                        <Col xl={3} lg={3} md={3}>
                            Póliza:
                        </Col>
                        <Col xl={9} lg={9} md={9}>
                            {this.state.poliza}
                        </Col>
                    </Row>
                    <Row>
                        <Col xl={3} lg={3} md={3}>
                            Sucursal:
                        </Col>
                        <Col xl={9} lg={9} md={9}>
                            {this.state.sucursal}
                        </Col>
                    </Row>
                    <Row>
                        <Col xl={3} lg={3} md={3}>
                            Ramo:
                        </Col>
                        <Col xl={9} lg={9} md={9}>
                            {this.state.ramo}
                        </Col>
                    </Row>
                </Col>
                <Col>
                    <Row>
                        <Col xl={3} lg={3} md={3}>
                            Código ítem:
                        </Col>
                        <Col xl={9} lg={9} md={9}>
                            {this.state.cod_item}
                        </Col>
                    </Row>
                    <Row>
                        <Col xl={3} lg={3} md={3}>
                            Provincia:
                        </Col>
                        <Col xl={9} lg={9} md={9}>
                            {this.state.provincia}
                        </Col>
                    </Row>
                    <Row>
                        <Col xl={3} lg={3} md={3}>
                            Ciudad:
                        </Col>
                        <Col xl={9} lg={9} md={9}>
                            {this.state.ciudad}
                        </Col>
                    </Row>
                </Col>
                <Col>
                    <Row>
                        <Col xl={3} lg={3} md={3}>
                            Dirección:
                        </Col>
                        <Col xl={9} lg={9} md={9}>
                            {this.state.direccion}
                        </Col>
                    </Row>
                </Col>
            </Row>
        )
    }

    renderMensajeCantidad = () => {
        const desde = this.state.totalRecords === 0 ? 0 : this.state.first + 1;
        const hasta = Math.min(this.state.first + this.state.rows, this.state.totalRecords);

        return (
            <Col>
                {`Mostrando ${desde} - ${hasta} de ${this.state.totalRecords} items`}
            </Col>
        );
    }

    onRegresarEndoso = () => {
        this.setState({
            paso: "coberturas"
        });
    }

    parseoRenderizadoEndoso = () => {
        const {
            ciudad,
            direccion,
            provincia,
            cod_item,
            sumaAseguradaLabel,
            ramo_tec,
            subramo

        } = this.props.general;

        const {
            datosEndosos
        } = this.props.datosEndosos;

        const { listado } = this.state;

        const sumas = {};

        const itemAsegurado = [
            {
                "label": "Código item:",
                "value": cod_item
            },
            {
                "label": "Provincia:",
                "value": provincia
            },
            {
                "label": "Ciudad:",
                "value": ciudad
            },
            {
                "label": "Direccion:",
                "value": direccion
            },
            {
                "label": "Ramo:",
                "value": ramo_tec
            }
        ];

        listado.forEach((lista)=>{
            sumas[lista.tipo] = lista.sumaAsegurada; 
        });
        
        this.setState({
            cabecera: this.renderDataCabecera(itemAsegurado),
            endosoSeleccionado: {
                data: {
                    ...this.props.general,
                    sumaAseguradaLabel: datosEndosos.sumaAseguradaTotalLabel,
                    sumaAsegurada: datosEndosos.sumaAseguradaTotal,
                },
                coberturasSeleccionadas: this.state.coberturasSeleccionadas,
                dataItemAsegurado: itemAsegurado,
                sumasAseguradas: sumas
            },
            paso: "seleccionEndoso",
            onRegresar: this.onRegresarEndoso
        });
        return;

    }

    onCheckCoberturas = (cambio, data) => {
        const { coberturasSeleccionadasChecked, coberturasSeleccionadas } = this.state;
        if (cambio === false) {
            delete coberturasSeleccionadas[data.tipo];
        } else {
            coberturasSeleccionadas[data.tipo] = data;
        }
        coberturasSeleccionadasChecked[data.tipo] = cambio;
        this.setState({
            coberturasSeleccionadasChecked,
            coberturasSeleccionadas
        });
    }

    renderDataCabecera = (itemAsegurado) => {
        const ramoStyle = {
            div: {
                xl: 3,
                lg: 3,
                md: 3
            },
            label: {
                xl: 12,
                lg: 12,
                md: 12
            },
        };

        const datosRamo =
        {
            titulo: "Datos póliza:",
            datos: [
                {
                    "label": "Póliza N:",
                    "value": this.state.poliza
                },
                {
                    "label": "Sucursal:",
                    "value": this.state.sucursal
                },
                {
                    "label": "Ramo:",
                    "value": this.state.ramo
                }
            ]
        }

        const aseguradoStyle = {
            div: {
                xl: 9,
                lg: 9,
                md: 9
            },
            label: {
                xl: 6,
                lg: 6,
                md: 6
            },
        }

        const datosAsegurado = {
            titulo: "Datos ítem asegurado:",
            datos: itemAsegurado
        }


        return (
            <Row style={{ marginLeft: 0, marginRight: 0 }}>
                <Col xl={ramoStyle.div.xl} lg={ramoStyle.div.lg} md={ramoStyle.div.md} >
                    <div style={{ fontWeight: "bold", marginBottom: "10px" }}>
                        {datosRamo.titulo}
                    </div>
                    <Row>
                        {
                            datosRamo.datos.map((dato) => (
                                <Col xl={ramoStyle.label.xl} lg={ramoStyle.label.lg} md={ramoStyle.label.md} style={{ marginBottom: "0px" }}>
                                    <div className="d-flex">
                                        <div style={{ width: "80px", fontSize: "16px" }}>
                                            {dato.label}
                                        </div>
                                        <div style={{ fontSize: "16px" }}>
                                            {dato.value}
                                        </div>
                                    </div>
                                </Col>
                            ))
                        }
                    </Row>

                </Col>
                <Col xl={aseguradoStyle.div.xl} lg={aseguradoStyle.div.lg} md={aseguradoStyle.div.md}>
                    <div style={{ fontWeight: "bold", marginBottom: "10px" }}>
                        {datosAsegurado.titulo}
                    </div>
                    <Row>
                        {
                            datosAsegurado.datos.map((dato) => (
                                <Col xl={aseguradoStyle.label.xl} lg={aseguradoStyle.label.lg} md={aseguradoStyle.label.md} style={{ marginBottom: "0px" }}>
                                    <div className="d-flex">
                                        <div style={{ width: "160px", fontSize: "16px" }}>
                                            {dato.label}
                                        </div>
                                        <div style={{ width: "350px", fontSize: "16px" }}>
                                            <p>{dato.value}</p>
                                        </div>
                                    </div>
                                </Col>
                            ))
                        }
                    </Row>
                </Col>
            </Row>
        )
    }

    onRegresar = () => {
        this.props.regresar();
    }

    onRenderCoberturas = () => {
        const {
            listado,
            coberturasSeleccionadasChecked
        } = this.state;

        const {
            funciones
        } = this.props;
        return (
            <Page
                title={
                    "Items hogar"
                }
            >
                {listado.length > 0 && (
                    <div>
                        <Row>
                            <Col xl={12} style={{ marginBottom: "0px" }}>
                                <Row style={{ marginLeft: 0, marginRight: 0 }}>
                                    <Col>
                                        <Button className={"button-white"} onClick={() => { this.onRegresar() }}>
                                            <i className="fa fa-chevron-circle-left" aria-hidden="true" />{" "}
                                            REGRESAR
                                        </Button>
                                    </Col>
                                </Row>
                            </Col>
                            <Col>
                                {this.renderDataRamo()}
                                {this.renderMensajeCantidad()}
                                <Card body>
                                    <DataTable
                                        value={listado}
                                        responsive
                                        className="p-datatable-customers"
                                        rowHover
                                        paginator={false}
                                        emptyMessage="No se han encontrado resultados"
                                        resizableColumns
                                    >
                                        <Column
                                            className="counter"
                                            field="contador"
                                            header="#"
                                            style={{ width: "60px" }}
                                        />
                                        <Column
                                            header="Tipo"
                                            field="tipo"
                                            sortable
                                            style={{ width: "100px" }}
                                        />
                                        <Column
                                            header="Suma Asegurada"
                                            field="sumaAseguradaLabel"
                                            sortable
                                            style={{ width: "100px" }}
                                        />
                                        <Column
                                            header="Seleccionar"
                                            body={(rowData) => {
                                                return (
                                                    <Col sm={12} style={{ justifyItems: "center", textAlign: "center", margin: "1.5px" }}>
                                                        <Checkbox
                                                            id={`coberturaSeleccionada-${rowData.tipo}`} // Optional.[String].Default: "".  Input ID.
                                                            name={"coberturaSeleccionada"} // Optional.[String].Default: "". Input name
                                                            value={coberturasSeleccionadasChecked[rowData.tipo] || false} // Required.[String].Default: "".
                                                            onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                                                            checked={coberturasSeleccionadasChecked[rowData.tipo] || false} // Required.[Bool].Default: false.
                                                            onChange={(cambio, e) => {
                                                                this.onCheckCoberturas(cambio, rowData);
                                                                //console.log(e);
                                                            }} // Required.[Func].Default: () => {}. Will return the value.
                                                            validationOption={{
                                                                name: "coberturaSeleccionada", // Optional.[String].Default: "". To display in the Error message. i.e Please check the .
                                                                check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                                                required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                                                            }}
                                                            customStyleInput={{
                                                                backgroundColor: "#4d4dd5",
                                                                width: 50,
                                                                height: 50,
                                                            }}
                                                        />
                                                    </Col>
                                                );
                                            }}
                                            style={{ width: "50px" }}
                                        />
                                    </DataTable>
                                    <div style={{ display: "flex", justifyContent: "end", marginTop: "10px" }}>
                                        <Button className={"btn btn-primary"} onClick={() => {
                                            this.parseoRenderizadoEndoso();
                                        }
                                        }>
                                            <p style={{ margin: 0 }}>Generar endoso</p>
                                        </Button>
                                    </div>

                                </Card>

                            </Col>
                        </Row>
                    </div>

                )}

                {listado.length === 0 && (
                    <Row>
                        <Col xl={12} style={{ marginBottom: "0px" }}>
                            <Row style={{ marginLeft: 0, marginRight: 0 }}>
                                <Col>
                                    <Button className={"button-white"} onClick={() => { this.onRegresar() }}>
                                        <i className="fa fa-chevron-circle-left" aria-hidden="true" />{" "}
                                        REGRESAR
                                    </Button>
                                </Col>
                            </Row>
                        </Col>
                        <Col
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                            className="detalle-cotizacion-box"
                        >
                            <Card className="mb-3">
                                <CardHeader style={{ borderBottom: "none" }}></CardHeader>
                                <CardBody>
                                    <h2 style={{ color: "#001871", textAlign: "center" }}>
                                        {" "}
                                        NO SE HA ENCONTRADO REGISTROS DE HOGAR ASOCIADOS
                                    </h2>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                )}
            </Page>
        )

    }

    renderSeleccionEndoso = () => {
        return (
            <SeleccionEndososHogar
                {...this.state}
                funciones={
                    {
                        cancelarEndoso: this.cancelarEndoso
                    }
                }
            />
        )
    }

    render() {
        const {
            paso
        } = this.state;
        return (
            <>
                {paso === "coberturas" && this.onRenderCoberturas()}
                {paso === "seleccionEndoso" && this.renderSeleccionEndoso()}
            </>
        )
    }
}

const mapStateToProps = (state) => ({
    datosEndosos: state.dataEndosos
});

const mapDispatchToProps = (dispatch) => {
    return {
        listadoEndososRamo: (body) => dispatch(FetchListadoCoberturas(body))
    };
};

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(CoberturasHogar)
);